module.exports = __webpack_public_path__ + "static/media/MX.3fbf70b4.png";